export async function InterconsultaUpdate(
    interDest,
    interDestAllow,
    interHilo,
    interconsultaId ) {
    const formData = {
        meta: {
            interDest: interDest,
            interDestAllow: interDestAllow,
            interHilo: interHilo,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/interconsulta/${interconsultaId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}